var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0586 62C49.1096 62 62.1216 49.0163 62.1216 33C62.1216 16.9982 49.1331 4.0234 33.1019 4.00003H33.0152C17.9025 4.02206 5.49385 15.554 4.12158 30.2813H36.4753L32.9524 26.766H32.9488C31.9483 25.6934 31.9803 24.0261 33.0162 22.9888C34.0557 21.9551 35.7267 21.9232 36.8017 22.9215L44.9757 31.0778C46.0365 32.1398 46.0365 33.8602 44.9757 34.9223L36.8017 43.0785C35.7374 44.137 34.0132 44.137 32.9489 43.0785C31.8881 42.0165 31.8881 40.2961 32.9489 39.234L36.4753 35.7188H4.12159C5.49518 50.4602 17.9263 62 33.0586 62Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.fdb7cea3.svg";
export { ForwardRef as ReactComponent };